if (!customElements.get('blog-loader')) {
  class BlogLoader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.button = this.querySelector('.js-load-more');
      this.actions = this.querySelector('.js-load-more-actions');
      this.loaderGrid = this.querySelector('.js-loader');
      this.url = this.button.getAttribute('href');

      this.actions.addEventListener('click', (event) => {
        event.preventDefault();

        fetch(this.url)
          .then((response) => response.text())
          .then((text) => {
            const html = new DOMParser().parseFromString(
              text,
              'text/html'
            );

            if (!html) return;
            this.loaderGrid.append(
              ...html.querySelector('.js-loader')?.childNodes
            );

            const loadMore = html.querySelector('.js-load-more');
            this.button = this.querySelector('.js-load-more');

            if (!loadMore) return this.button.remove();

            this.url = loadMore.getAttribute('href');

            this.button.parentElement.replaceChild(
              loadMore,
              this.button
            );
          })
          .catch((error) => console.error(error));
      });
    }
  }
  customElements.define('blog-loader', BlogLoader);
}
